import { render, staticRenderFns } from "./BelowFold.vue?vue&type=template&id=d8f760fa&"
import script from "./BelowFold.vue?vue&type=script&lang=js&"
export * from "./BelowFold.vue?vue&type=script&lang=js&"
import style0 from "./BelowFold.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports